module.exports = __webpack_public_path__ + "static/media/bottom-phone.8efb8b94.png";